module.exports = __webpack_public_path__ + "static/img/Sporting-Globe-Richmond.b9164a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sporting-Globe-Richmond.jpg
// module id = 52jU
// module chunks = 0